<div [@dialog] *ngIf="visible" class="dialog">
    <ng-content></ng-content>
    <button *ngIf="closable" (click)="close()" aria-label="Close" class="dialog__close-btn">
        <i class="fa fa-times" aria-hidden="true"></i>
        <span class="sr-only" aria-hidden="false">Close Message</span>
    </button>
</div>
<div *ngIf="visible" (click)="close()"></div>